
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/motorcycle-rental-license-requirements",
      function () {
        return require("private-next-pages/motorcycle-rental-license-requirements.js");
      }
    ]);
  